import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    boxSizing: 'border-box',
    minHeight: '114px',
    height: '114px',
    maxHeight: '114px',
    backgroundColor: ({ selected }) => (selected ? '#F8D8FF' : 'white'),

    '&:not(:last-child)': {
      borderBottom: '1px solid lightgrey'
    },

    '&:last-child': {
      marginBottom: '30px'
    }
  },

  topArea: {
    display: 'flex',
    paddingTop: '16px',
    paddingLeft: '24px',
    paddingBottom: '8px'
  },

  avatar: {
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    animation: '$skeleton-loading 0.3s linear infinite alternate'
  },

  topText: {
    marginLeft: '16px',
    borderRadius: '10px',
    width: 'calc(100% - 5rem)',
    animation: '$skeleton-loading 0.3s linear infinite alternate'
  },

  bottomArea: {
    marginLeft: '24px',
    borderRadius: '10px',
    width: 'calc(100% - 48px)',
    height: '17px',
    paddingBottom: '16px',
    animation: '$skeleton-loading 0.3s linear infinite alternate'
  },

  '@keyframes skeleton-loading': {
    '0%': {
      backgroundColor: 'hsl(0, 0%, 90%)'
    },

    '100%': {
      backgroundColor: 'hsl(0, 0%, 93%)'
    }
  }
}))

export default useStyles
